const enterpriseIds = {    
	language_trainings: 'lkmlanguagetrainings',
    lead_ambrish: 'ambrish.rastogi',
    lead_anirudh: 'anirudh.a.goel',
    lead_abhilash: 'abhilash.d.bungale',
    lead_shruti: 'shruti.aggarwal',
    varsha_tyagi:'varsha.a.tyagi',
    akash_aluru:'aluru.akash',
    ankur_mishra:'ankur.e.mishra',
    srinivasan_harini:'h.srinivasan',
    jeevadharini_ramanan:'jeevadharani.ramanan',
    arpita_singh:'arpita.m.singh',
    umarani_battu:'uma.rani.battu',
    reshmi_haridas:'reshmi.haridas.m',
    aayushi_bharti:'aayushi.bharti'
}
const domain = 'accenture.com';
const dsDomain = 'ds.dev.accenture.com';
const languageTrainings = `${enterpriseIds.language_trainings}@${domain}`;
const leadAmbrish = `${enterpriseIds.lead_ambrish}@${domain}`;
const leadAnirudh = `${enterpriseIds.lead_anirudh}@${domain}`;
const leadAbhilash = `${enterpriseIds.lead_abhilash}@${domain}`;
const leadShruti = `${enterpriseIds.lead_shruti}@${domain}`;
const varshaTyagi = `${enterpriseIds.varsha_tyagi}@${domain}`;
const akashAluru = `${enterpriseIds.akash_aluru}@${domain}`;
const ankurMishra = `${enterpriseIds.ankur_mishra}@${domain}`;
const srinivasanHarini = `${enterpriseIds.srinivasan_harini}@${domain}`;
const jeevadhariniRamanan = `${enterpriseIds.jeevadharini_ramanan}@${domain}`;
const arpitaSingh = `${enterpriseIds.arpita_singh}@${domain}`;
const umaraniBattu = `${enterpriseIds.umarani_battu}@${domain}`;
const reshmiHaridas = `${enterpriseIds.reshmi_haridas}@${domain}`;
const aayushiBharti = `${enterpriseIds.aayushi_bharti}@${domain}`;
const varshaTyagiDs = `${enterpriseIds.varsha_tyagi}@${dsDomain}`;
const akashAluruDs = `${enterpriseIds.akash_aluru}@${dsDomain}`;
const ankurMishraDs = `${enterpriseIds.ankur_mishra}@${dsDomain}`;
const srinivasanHariniDs = `${enterpriseIds.srinivasan_harini}@${dsDomain}`;
const jeevadhariniRamananDs = `${enterpriseIds.jeevadharini_ramanan}@${dsDomain}`;
const arpitaSinghDs = `${enterpriseIds.arpita_singh}@${dsDomain}`;
const umaraniBattuDs = `${enterpriseIds.umarani_battu}@${dsDomain}`;
const reshmiHaridasDs = `${enterpriseIds.reshmi_haridas}@${dsDomain}`;
const aayushiBhartiDs = `${enterpriseIds.aayushi_bharti}@${dsDomain}`;

export default {languageTrainings,leadAmbrish,leadAnirudh,leadAbhilash,leadShruti,varshaTyagi,akashAluru,
ankurMishra,srinivasanHarini,jeevadhariniRamanan,arpitaSingh,umaraniBattu,reshmiHaridas,aayushiBharti,
varshaTyagiDs,akashAluruDs,ankurMishraDs,srinivasanHariniDs, jeevadhariniRamananDs,arpitaSinghDs, umaraniBattuDs,reshmiHaridasDs,aayushiBhartiDs }